import React from "react";
import "./services.css";
import TruncatedListWithPopover from "../TruncatedListWithPopover";
import { Tag } from "antd";

const Services = ({ services, status, direction }) => {
  const parseResponse = (response) => {
    const parsedResponse = JSON.parse(response);    
    if (Object.keys(parsedResponse[0]).includes("formName")) {
      return parsedResponse.map((item) => item?.formName);
    } else {
      return parsedResponse?.map((item) => JSON.parse(item || "{}")?.title);
    }
  };

  return (
    <>
      {
        <TruncatedListWithPopover
          dataList={parseResponse(services)}
          dataToBeDisplayed={status && status !== "Active" ? 2 : 3}
          direction={direction}
        />
      }
      <div>
        {status && status !== "Active" && <Tag key="veteran">{status}</Tag>}
      </div>
    </>
  );
};

export default Services;
